import { useSession } from 'next-auth/react';
import { usePostHog } from 'posthog-js/react';
import { createContext, useContext, useEffect, ReactNode } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

interface TrackingContextValue {
  // Add tracking methods here when needed
  track?: (event: string, properties?: Record<string, unknown>) => void;
}

const TrackingContext = createContext<TrackingContextValue | undefined>(
  undefined,
);

export function useTracking(): TrackingContextValue | undefined {
  return useContext(TrackingContext);
}

interface TrackingProviderProps {
  children: ReactNode;
}

export function TrackingProvider({ children }: TrackingProviderProps) {
  const { data: session } = useSession();
  const posthogInstance = usePostHog();

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host:
          process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
        defaults: '2025-05-24',
        loaded: (posthog) => {
          if (process.env.NODE_ENV === 'development') posthog.debug();
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!session?.user) {
      return;
    }

    const user = {
      id: (session.user as any).id,
      email: session.user.email,
      nome: session.user.name,
    };

    posthogInstance.identify(user.id, user);
  }, [session, posthogInstance]);

  return (
    <PostHogProvider client={posthog}>
      <TrackingContext.Provider value={{}}>
        {children}
      </TrackingContext.Provider>
    </PostHogProvider>
  );
}
